export default __webpack_public_path__ + "static/media/error-page-image.637debd5.gif";